export default [
  {
    path: "/VerificationLogin",
    component: (resolve: any) => require(["@/views/system/user/VerificationLogin.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/Register",
    component: (resolve: any) => require(["@/views/system/user/Register.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/businessRegister",
    component: (resolve: any) => require(["@/views/system/user/businessRegister.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/user/main",
    name: "main",
    component: (resolve: any) => require(["@/views/system/user/main.vue"], resolve),
    meta: {
      index: 3,
    },
  },
  {
    path: "/system/user/account",
    component: (resolve: any) => require(["@/views/system/user/account/account.vue"], resolve),
  },
  // {
  //   path: "/system/user/editProfile",
  //   component: (resolve: any) => require(["@/views/system/user/account/editProfile.vue"], resolve),
  // },
  {
    path: "/system/user/accountRelating",
    component: (resolve: any) => require(["@/views/system/user/account/accountRelating.vue"], resolve),
  },
  {
    path: "/system/user/editPassword",
    component: (resolve: any) => require(["@/views/system/user/account/editPassword.vue"], resolve),
  },
  {
    path: "/system/user/notice",
    component: (resolve: any) => require(["@/views/system/user/notice.vue"], resolve),
  },
  // {
  //   path: "/reset",
  //   component: (resolve: any) => require(["@/views/system/user/reset.vue"], resolve),
  // },
  {
    name: "BindingAccount",
    path: "/system/user/bindingAccount",
    component: (resolve: any) => require(["@/views/system/user/account/BindingAccount.vue"], resolve),
  },
  {
    name: "approvalSetList",
    path: "/system/approvalSet/list",
    component: (resolve: any) => require(["@/views/system/approvalSet/list.vue"], resolve),
  },
  // {
  //   name: 'approvalSetDetail',
  //   path: '/system/approvalSet/detail',
  //   component:(resolve:any)=> require(['@/views/system/approvalSet/detail.vue'], resolve)
  // },
  {
    name: "download",
    path: "/system/download",
    component: (resolve: any) => require(["@/views/system/download/download.vue"], resolve),
  },
  {
    name: "about",
    path: "/system/about",
    component: (resolve: any) => require(["@/views/system/about/about.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    name: "servicePolicy",
    path: "/system/servicePolicy",
    component: (resolve: any) => require(["@/views/system/about/servicePolicy.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    name: "privacySettings",
    path: "/system/privacySettings",
    component: (resolve: any) => require(["@/views/system/about/privacySettings.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    name: "privacyPolicy",
    path: "/system/privacyPolicy",
    component: (resolve: any) => require(["@/views/system/about/privacyPolicy.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    name: "notify",
    path: "/system/notify",
    component: (resolve: any) => require(["@/views/system/notify/notify.vue"], resolve),
  },
  {
    name: "messageNotify",
    path: "/system/messageNotify",
    component: (resolve: any) => require(["@/views/system/messageNotify/messageNotify.vue"], resolve),
  },
  {
    name: "feedBack",
    path: "/system/feedBack",
    component: (resolve: any) => require(["@/views/system/feedBack/feedBack.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    name: "configInfo",
    path: "/system/configInfo",
    component: (resolve: any) => require(["@/views/system/configInfo/configInfo.vue"], resolve),
  },
  {
    path: "/system/address",
    component: (resolve: any) => require(["@/views/system/address.vue"], resolve),
  },
  {
    path: "/system/newaddress",
    component: (resolve: any) => require(["@/views/system/NewAddress.vue"], resolve),
  },
  {
    path: "/reset",
    component: (resolve: any) => require(["@/views/system/user/reset.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/wechat",
    component: (resolve: any) => require(["@/views/system/user/wechat.vue"], resolve),
    meta: {
      authorize: false,
    },
  },
  {
    path: "/system/invoice",
    component: (resolve: any) => require(["@/views/system/mall/invoice.vue"], resolve),
  },
  {
    path: "/system/addInvoice",
    component: (resolve: any) => require(["@/views/system/mall/addInvoice.vue"], resolve),
  },
  {
    path: "/system/oftenPassenger",
    component: (resolve: any) => require(["@/views/system/mall/oftenPassenger.vue"], resolve),
  },
  {
    path: "/system/addTraveller",
    component: (resolve: any) => require(["@/views/system/mall/addTraveller.vue"], resolve),
  },
];
